import { CouponApplyPhase } from "./interfaces/coupon-qualifier.interface";
import { CouponApplyErrorCode, AppType } from "../../core/enums";
export class StoreLimitQualifier {
    phase = CouponApplyPhase.PreApply;
    _appType;
    _data;
    constructor(appType, sourceData) {
        this._appType = appType;
        this._data = sourceData;
    }
    qualify(coupon, cart) {
        // loyalty redeem item coupon is exempt from store limit checks
        if (coupon.couponId === 7 /* DiscountType.LOYALTY_REDEEM_ITEM */)
            return { isValid: true, errorCode: null };
        if (coupon.limitsPerOrder === 4 /* CouponLimitPerOrder.OVERRIDE_207 */)
            return { isValid: true, errorCode: null };
        const coupons = cart.activeCouponIds.filter(x => x !== 7 /* DiscountType.LOYALTY_REDEEM_ITEM */ &&
            this._data.coupons.find(c => c.couponId === x)?.limitsPerOrder !== 4 /* CouponLimitPerOrder.OVERRIDE_207 */);
        if (coupons.length === 0)
            return { isValid: true, errorCode: null };
        const oneCouponLimit = this._data.settings.CPNLIM;
        switch (this._appType) {
            case AppType.OLO:
                if (oneCouponLimit === 2 /* StoreCouponLimitType.ONLINE_ONLY */ || oneCouponLimit === 3 /* StoreCouponLimitType.BOTH */) {
                    return { isValid: false, errorCode: CouponApplyErrorCode.COUPON_LIMIT_ONE };
                }
                break;
            case AppType.POS:
                if (oneCouponLimit === 1 /* StoreCouponLimitType.IN_STORE_ONLY */ || oneCouponLimit === 3 /* StoreCouponLimitType.BOTH */) {
                    return { isValid: false, errorCode: CouponApplyErrorCode.COUPON_LIMIT_ONE };
                }
                break;
        }
        return { isValid: true, errorCode: null };
    }
}
//# sourceMappingURL=store-limit.js.map